import type {CertadocFinesByCategory} from 'src/core/data/api/Certadoc';
import BaseService from './base-service';

export default class CertadocService extends BaseService {
  constructor() {
    super('certadoc');
  }

  fines(deviceId: number): Promise<CertadocFinesByCategory> {
    return this.__get(`${this.url}/fines?deviceId=${deviceId}`);
  }

  enabled(): Promise<{enabled: boolean}> {
    return this.__get(`${this.url}/enabled`);
  }
}
